import React from 'react';
import { Table, Button} from 'semantic-ui-react';
import {NoData} from "../../components/table/no-data";
import {Link} from "react-router-dom";
import {translateSiteName} from "../../helpers/data-helpers";

export default class SiteFundTableRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
}


  render() {

    const { selected, data, onRowSelect } = this.props;

  return (
    <Table.Row
    onClick={() => onRowSelect(data.siteKey)}
    style={{ backgroundColor: selected ? '#7ABF80': 'none' }}
  >
            <Table.Cell>{ translateSiteName(this.props.data) || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.town || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.postcode || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.fund || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.fundName || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.locationId || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.siteStatus || <NoData/>}</Table.Cell>
        <Table.Cell>
            <Link to={ { pathname: '/site',
                search: `siteKey=${this.props.data.siteKey}`}
                 }>
                <Button basic >Site Details</Button>
            </Link>
        </Table.Cell>
      </Table.Row>
    );
  }
}